<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <div class="row my-3">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
                    <div class="w-full ">
                        <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                        <div class="d-flex align-items-center mb-3">
                          <span class="me-2">Mostrar:</span>
                          <select 
                            v-model="itemsPerPage" 
                            @change="resetPagination"
                            class="form-select w-auto"
                          >
                            <option :value="10">10</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                          </select>
                          <span class="ms-2">registros</span>
                        </div>
                        <!-- Container para botón y filtros -->
                        <div class="flex justify-between items-center w-full mb-4">
                          <!-- Botón a la izquierda -->
                          <button @click="goToPropertyForm(advisorId)" class="custom-create-btn">
                            <span class="custom-create-btn-text">Crear Propiedad</span>
                          </button>

                          <!-- Contenedor de filtros a la derecha -->
                          <div class="flex gap-2">
                            <!-- Selector de tipo de inmueble -->
                            <select 
                              v-model="propertyTypeFilter"
                              class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                            >
                              <option value="">Todos los tipos</option>
                              <option value="Casa">Casa</option>
                              <option value="Departamento">Departamento</option>
                              <option value="Terreno">Terreno</option>
                              <option value="Local">Local</option>
                              <option value="Oficina">Oficina</option>
                            </select>

                            <!-- Selector de estatus -->
                            <select 
                              v-model="statusFilter"
                              class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                            >
                              <option value="">Todos los estatus</option>
                              <option value="Activo">Activo</option>
                              <option value="Desactivado">Desactivado</option>
                              <option value="Sin estatus">Sin estatus</option>
                            </select>

                            <!-- Input del buscador -->
                            <input
                              type="text"
                              class="w-64 px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                              placeholder="Buscar"
                              v-model="searchQuery"
                            />
                          </div>
                        </div>
                    </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                                <tr>
                                <th class="py-3 px-6 text-style-custom text-left">Código</th>
                                <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                                <th class="py-3 px-6 text-style-custom text-left">Tipo de Inmueble</th>
                                <th class="py-3 px-6 text-style-custom text-left">Movimiento</th>
                                <th class="py-3 px-6 text-style-custom text-left">Precio venta</th>
                                <th class="py-3 px-6 text-style-custom text-left">Precio Renta</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estado</th>
                                <th class="py-3 px-6 text-style-custom text-left">Municipio</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estatus</th>
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                                <tr
                                v-for="(properties, index) in filteredCargos"
                                :key="index"
                                class="border-b border-gray-200 hover:bg-gray-100"
                                >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.property_code }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ truncatedDescription (properties.property_name) }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.type_property }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.type_movement}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.property_value}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.rent_value}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.state }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.municipality }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.translatedStatus || 'Sin estatus' }}</td>
                                <td class="py-3 px-6 text-center">
                                  <div class="relative" ref="el => menuContainers.push(el)">
                                    <!-- Contenedor clickeable -->
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-200"
                                      @click.stop="toggleMenu(properties.id)"
                                    >
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none"
                                      >
                                        <path 
                                          fill-rule="evenodd" 
                                          clip-rule="evenodd" 
                                          d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                          fill="#FF4265"
                                        />
                                      </svg>
                                    </div>

                                    <!-- Menú desplegable -->
                                    <div 
                                      v-show="menuVisible === properties.id" 
                                      :class="{
                                        'absolute right-0 bg-white border shadow-lg mt-1 w-48 z-10': true,
                                        'bottom-full mb-1': index === filteredCargos.length - 1 || index === filteredCargos.length - 2, // Si es el último o antepenúltimo registro, despliega hacia arriba
                                        'top-full mt-1': index < filteredCargos.length - 2 // De lo contrario, despliega hacia abajo
                                      }"
                                    >
                                      <ul class="py-1">
                                        <!-- Editar -->
                                        <li 
                                          v-if="properties.translatedStatus !== 'Desactivado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                                          @click="editCargo(properties.id)"
                                        >
                                          Editar
                                        </li>
                                        <!-- Activar -->
                                        <li 
                                          v-if="properties.translatedStatus === 'Desactivado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-green-500" 
                                          @click="confirmActive(properties.id)"
                                        >
                                          Activar
                                        </li>
                                        <!-- Desactivar -->
                                        <li 
                                          v-else 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" 
                                          @click="deleteCargo(properties.id)"
                                        >
                                          Desactivar
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <DeleteModal
                          v-if="showModal"
                          :visible="showModal"
                          @close="showModal = false"
                          @confirm="confirmDelete"
                        />
                    </div>
                    <div class="flex justify-between items-center w-full">
                      <div class="w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                        Mostrando {{ currentPage }} de {{ totalPages }}
                      </div>
                      <!-- Pagination Controls -->
                      <div style="display: flex; justify-content: flex-end; align-items: center; padding: 8px 12px;">
                        <button 
                          @click="changePage(currentPage - 1)" 
                          :disabled="currentPage === 1"
                          class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :style="{padding: '8px 12px', border: '1px solid var(--Primary-Primary,  #FFD8DF)', background: 'var(--Primary-Primary, #FFF)', color: '#FF4265', opacity: page === 1 ? '0.5' : '1',cursor: page === 1 ? 'not-allowed' : 'pointer' }"
                        >
                          &lt;
                        </button>
                        
                        <!-- Números de página -->
                        <div style="display: flex; gap: 0; align-items: center;">
                            <button
                              v-for="pageNumber in totalPages" 
                              :key="pageNumber" @click="changePage(pageNumber)" 
                              :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: pageNumber === page ? '#FF4265' : 'var(--Primary-Primary, #FFF)',color: pageNumber === page ? '#FFF' : '#FF4265',fontWeight: pageNumber === page ? 'bold' : 'normal',
                                cursor: 'pointer'
                              }"
                            >
                              {{ pageNumber }}
                            </button>
                          </div>
                        
                        <button 
                          @click="changePage(currentPage + 1)" 
                          :disabled="currentPage === totalPages"
                          class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: 'var(--Primary-Primary, #FFF)',color: '#FF4265',opacity: page >= totalPages ? '0.5' : '1',cursor: page >= totalPages ? 'not-allowed' : 'pointer'
                          }"
                        >
                          &gt;
                        </button>
                      </div>
                    </div>
                  </div>
                  <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
    </div>        

</template>
  
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import { useRoute } from "vue-router";
  import 'vue-toastification/dist/index.css';
  import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/properties/Modal/DeletePropertiesModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  //const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const menuVisible = ref(null);
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const route = useRoute();
  //let userId = computed(() => route.params.id);
  let advisorId = computed(() => route.params.id);
  const properties = ref([]);
  const page = ref(1); // Página actual
  //const company = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedCargoId = ref(null);
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(20); // Number of items to show per page
  const menuContainers = ref([]); 
  const statusFilter = ref(''); // Nuevo ref para el filtro de estatus
  const  propertyTypeFilter = ref('');

  // Métodos
  async function get_propierties() {
      try {
          let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/property`;
          var options = {
              headers: {
                  "Content-Type": "application/json", 
                  Authorization: `Bearer ${session.value.token_api}`, 
              },
          };

          const response = await axios.get(url_cnn, options);

          if (response.status === 200 && response.data?.properties) {
              // Verificamos la respuesta con un console.log
              console.log(response.data.properties);

              // Mapear propiedades y traducir status
              properties.value = response.data.properties.map(property => {
                  console.log("Estado original:", property.status_id);  // Verifica el estado original
                  const translatedStatus = translateStatus(property.status_id);
                  console.log("Estado traducido:", translatedStatus); // Verifica la traducción
                  return {
                      ...property,
                      translatedStatus: translatedStatus
                  };
              });
          }

      } catch (error) {
          if (error.response.status === 401) {
              store.dispatch("clearUserSession");
              router.push({ name: "login" });
          }
      } finally {
          isLoading.value = false;
      }
  }

  const deleteCargo = (cargo_id) => {
    if (!cargo_id) {
      console.error("No se proporcionó un ID válido");
      return;
    }
    selectedCargoId.value = cargo_id;
    showModal.value = true;
  };

  //const profileCompany = (id) => {
  //    console.log("ID del rol:", id); // Imprime el ID en la consola
  //    router.push({ name: 'compañia-profile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  //};

  async function confirmDelete() {
    try {
      if (!selectedCargoId.value) {
        throw new Error("No se ha seleccionado ninguna propiedad");
      }

      const options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json'
        }
      };

      const data = { 
        property_id: selectedCargoId.value // Change cargo_id to property_id
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/property-delete`,
        data,
        options
      );

      if (response.status === 200) {
        showModal.value = false;
        await get_propierties(); // Refresh the properties list
        return response.data.message;
      }

    } catch (error) {
      console.error("Error al intentar eliminar la propiedad:", error);
      
      // Handle specific error cases
      if (error.response?.status === 404) {
        console.error("La propiedad no fue encontrada");
      } else if (error.response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      }
      
      throw error; // Re-throw the error to be handled by the caller if needed
    }
  }
  const confirmActive = async (cargo_id) => {
    if (!cargo_id) {
      console.error("No se proporcionó un ID válido");
      return;
    }
    
    selectedCargoId.value = cargo_id;
    
    try {
      const options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json',
        },
      };
      
      const data = { 
        property_id: selectedCargoId.value // Changed from cargo_id to property_id
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/property-active`, 
        data, 
        options
      );

      if (response.status === 200) {
        showModal.value = false;
        console.log("Propiedad activada correctamente:", response.data.message); // Updated message
        await get_propierties(); // Added await
        return response.data.message;
      }
      
      return response.data.message;
    } catch (error) {
      console.error('Error al activar la propiedad:', error); // Updated error message
      
      // Handle specific error cases
      if (error.response?.status === 404) {
        console.error("La propiedad no fue encontrada");
      } else if (error.response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      }
      
      throw error;
    }
  };
  const translateStatus = (status) => {
    // Verifica si el estado es null o undefined
    if (status === null || status === undefined) {
      return 'Sin estatus';
    }

    const statusTranslations = {
      1: 'Activo',
      2: 'Desactivado',
      3: 'Eliminada',
      // Agrega más traducciones según sea necesario
    };

    return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
  };
    const goToPropertyForm = (advisorId) => {
    router.push({ 
      name: 'propertyForm', 
      params: { advisorId } // Envías el ID del asesor como parámetro
    });
  };
    const editCargo = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'propertyFormEdit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
    };

    const resetPagination = () => {
      page.value = 1; // Reset to first page
    };
    const truncatedDescription = (property_name) => {
          const maxLength = 34; // Establece el límite de caracteres que quieres mostrar
          if (property_name.length > maxLength) {
            return property_name.substring(0, maxLength) + '...'; // Recorta y añade "..."
          }
          return property_name; // Si no es largo, muestra la descripción completa
        };
    const filteredCargos = computed(() => {
      if (!Array.isArray(properties.value)) return [];

      let filtered = properties.value;

      // Aplicar filtro de búsqueda por nombre y código
      if (searchQuery.value) {
          filtered = filtered.filter(property => {
              const nameMatch = property.property_name && property.property_name.toLowerCase().includes(searchQuery.value.toLowerCase());
              const codeMatch = property.property_code && property.property_code.toLowerCase().includes(searchQuery.value.toLowerCase());
              return nameMatch || codeMatch; // Retorna verdadero si coincide con el nombre o el código
          });
      }

      // Aplicar filtro por tipo de inmueble
      if (propertyTypeFilter.value) {
          filtered = filtered.filter(property => 
              property.type_property === propertyTypeFilter.value
          );
      }

      // Aplicar filtro por estatus
      if (statusFilter.value) {
          filtered = filtered.filter(property => 
              property.translatedStatus === statusFilter.value
          );
      }

      // Paginar los resultados
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;

      return filtered.slice(start, end);
    });
    // Modificar el computed totalPages para considerar ambos filtros
    const totalPages = computed(() => {
        let filtered = properties.value;

        if (searchQuery.value) {
            filtered = filtered.filter(property =>
                property.property_name.toLowerCase().includes(searchQuery.value.toLowerCase()),
            );
        }

        if (propertyTypeFilter.value) {
            filtered = filtered.filter(property => 
                property.type_property === propertyTypeFilter.value
            );
        }

        if (statusFilter.value) {
            filtered = filtered.filter(property =>
                property.translatedStatus === statusFilter.value
            );
        }

        return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };
    // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      // Si el clic no fue dentro de ningún contenedor de menú, cerrar el menú visible
      if (!menuContainers.value.some(container => container?.contains(event.target))) {
        menuVisible.value = null;
      }
    };

    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  get_propierties();
  document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
  });

 
  
  </script>
  
  <style scoped>
    .card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 8px;
    }
  </style>